import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import * as AWS from "aws-sdk";
import { jwtDecode } from "jwt-decode"; // ✅ correct

import {
  CognitoIdentityProviderClient,
  AdminSetUserPasswordCommand,
} from "@aws-sdk/client-cognito-identity-provider";

export default class AWSCognitoManager {
  constructor(Region, UserPoolId, ClientId, IdentityPoolId) {
    this.userPoolId = UserPoolId;
    this.clientId = ClientId;
    this.region = Region;
    this.identityPoolId = IdentityPoolId;

    const poolData = {
      UserPoolId: this.userPoolId,
      ClientId: this.clientId,
    };
    this.userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

    this.cognitoUser = null;

    this.IDToken = null;
    this.AccessToken = null;
    this.UserLogged = false;
    this.Username = "";

    this.AWS = require("aws-sdk");
    this.AWS.config.region = Region;

    this.cognitoidentityserviceprovider =
      new this.AWS.CognitoIdentityServiceProvider({ apiVersion: "2016-04-18" });
    this.emailVerifier = new this.AWS.SES({ apiVersion: "2010-12-01" });

    return;
  }

  CreateCognitoUser(username) {
    var userData = {
      Username: username,
      Pool: this.userPool,
    };
    this.cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
  }

  async CreateDynamoDbClient() {
    await this.RefreshCredentials();
    return new AWS.DynamoDB();
  }
  async CreateLambdaClient() {
    await this.RefreshCredentials();
    return new AWS.Lambda();
  }
  async CreateS3Client() {
    await this.RefreshCredentials();
    return new AWS.S3(this.region);
  }

  async AuthenticateUser(username, password) {
    this.CreateCognitoUser(username);
    var authenticationData = {
      Username: username,
      Password: password,
    };
    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
      authenticationData
    );

    return new Promise((resolve, reject) => {
      this.cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: async (result) => {
          // Make the onSuccess callback async
          try {
            this.IDToken = result.getIdToken().getJwtToken();
            this.AccessToken = result.getAccessToken().getJwtToken();
            this.UserLogged = true;
            this.Username = username;
            this.password = password;

            sessionStorage.setItem("Logged", true);
            sessionStorage.setItem("Token", this.IDToken);
            sessionStorage.setItem("AccessToken", this.AccessToken);
            sessionStorage.setItem("Username", this.Username);
            sessionStorage.setItem("Password", this.password);

            await this.GetAWSCredentials(); // Await the async function

            resolve(true);
          } catch (error) {
            reject(error);
          }
        },
        onFailure: (err) => {
          this.UserLogged = false;
          console.log("Error in AuthenticateUser " + err);
          reject(err);
        },
      });
    });
  }

  async GetUserAttributes() {
    return new Promise((resolve, reject) => {
      this.cognitoUser.getUserAttributes((err, attributes) => {
        if (err) {
          console.error("Error fetching user attributes:", err);
          reject(err);
          return;
        }
        const attrs = {};
        attributes.forEach((attribute) => {
          attrs[attribute.getName()] = attribute.getValue();
          // You can also store them if needed:
        });
        //i need also to get the groups of the user
        this.GetUserGroups()
          .then((groups) => {
            attrs["Groups"] = groups;
            resolve(attrs);
          }
          )
          .catch((error) => {
            console.error("Error fetching user groups:", error);
            reject(error);
          });
        //
        resolve(attrs);
      });
    });
  }

  async LogoutUser() {
    return new Promise((resolve, reject) => {
      this.cognitoUser.signOut((err, session) => {
        if (err) {
          console.log("Error in LogoutUser " + err);
          reject(err);
        } else {
          this.IDToken = null;
          this.AccessToken = null;
          this.UserLogged = false;
          this.Username = "";
          resolve(true);
        }
      });
    });
  }

  async ForgotPassword(username) {
    this.CreateCognitoUser(username);
    return new Promise((resolve, reject) => {
      this.cognitoUser.forgotPassword({
        onSuccess: function (data) {
          console.log("CodeDeliveryData from forgotPassword: " + data);
          resolve(data);
          return true;
        },
        onFailure: function (err) {
          console.log("Error in ForgotPassword " + err.name);
          reject(err);
          return false;
        },
      });
    });
  }

  async SetUserPassword(UserPoolId, username, password, setAsPermanent) {
    var params = {
      Password: password,
      Permanent: setAsPermanent,
      Username: username,
      UserPoolId: UserPoolId,
    };
    await this.RefreshCredentials();
    const client = new CognitoIdentityProviderClient(this.AWS.config);
    const command = new AdminSetUserPasswordCommand(params);

    try {
      const response = await client.send(command);
      console.log("Password set successfully:", response);
    } catch (error) {
      console.error("Error setting password:", error);
    }
  }

  async ResetPassword(username,newPassword, code ) {
    this.CreateCognitoUser(username);
    return new Promise((resolve, reject) => {
      this.cognitoUser.confirmPassword(code, newPassword, {
        onSuccess() {
          resolve(0);
        },
        onFailure(err) {
          console.error("ERROR in Reset Password", err.name);
          if (err.name === "InvalidPasswordException") {
            resolve(1);
          } else if (err.name === "LimitExceededException") {
            resolve(2);
          } else if (err.name === "InvalidParameterException") {
            resolve(3);
          } else if (err.name === "CodeMismatchException") {
            resolve(3);
          } else if (err.name === "ExpiredCodeException") {
            resolve(3);
          } else {
            resolve(4);
          }
        },
      });
    });
  }

  async CreateUser(params, email, Username, UserPoolId = "", ClientID = "") {
    console.log(params);
    try {
      await this.RefreshCredentials();

      // Creazione utente
      const data = await new Promise((resolve, reject) => {
        this.cognitoidentityserviceprovider.signUp(params, (err, data) => {
          if (err) {
            console.error("Error in CreateUser", err);
            reject(err);
          } else {
            resolve(data);
          }
        });
      });

      console.log("User created:", data);

      // Conferma l'utente senza codice
      await this.cognitoidentityserviceprovider
        .adminConfirmSignUp({
          UserPoolId: UserPoolId,
          Username: Username,
        })
        .promise();

      console.log("User confirmed manually.");

      // Segna l'email come verificata
      await this.cognitoidentityserviceprovider
        .adminUpdateUserAttributes({
          UserPoolId: UserPoolId,
          Username: Username,
          UserAttributes: [{ Name: "email_verified", Value: "true" }],
        })
        .promise();

      console.log("Email marked as verified.");

      return data;
    } catch (error) {
      console.error("CreateUser failed:", error);
      throw error;
    }
  }

  async AddUserToGroup(UserPoolID, Groupname, Username) {
    console.log("Adding user to group");
    console.log("UserPoolID", UserPoolID);
    console.log("Groupname", Groupname);
    console.log("Username", Username);
    await this.RefreshCredentials();
    var params = {
      GroupName: Groupname /* required */,
      UserPoolId: UserPoolID /* required */,
      Username: Username /* required */,
    };
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.adminAddUserToGroup(
        params,
        function (err, data) {
          if (err) {
            console.log("Error", err);
            reject(err); // Reject the promise in case of error
          } else {
            console.log("User added to group");
            console.log(data);
            resolve(data); // Resolve the promise on success
          }
        }
      );
    });
  }

  async GetAWSCredentials() {
    this.AWS = require("aws-sdk");
    // Initialize identity provider of Amazon Cognito
    this.AWS.config.region = this.region; // Region

    const loginsKey =
      "cognito-idp." + this.region + ".amazonaws.com/" + this.userPoolId;

    if (
      this.AWS.config.credentials != null &&
      (this.AWS.config.credentials.expireTime < Date.now() ||
        this.AWS.config.credentials.expired)
    ) {
      await this.AuthenticateUser(
        sessionStorage.getItem("Username"),
        sessionStorage.getItem("Password")
      );
    }

    this.AWS.config.credentials = new this.AWS.CognitoIdentityCredentials({
      IdentityPoolId: this.identityPoolId,
      Logins: {
        [loginsKey]: sessionStorage.getItem("Token"),
      },
    });

    this.AWS.config.credentials.clearCachedId();

    this.AWS.config.credentials.refresh((error) => {
      if (error) {
        console.error(error);
        return;
      } else {
      }
    });

    await this.AWS.config.credentials.getPromise();

    this.accessKeyId = this.AWS.config.credentials.accessKeyId;
    this.secretAccessKey = this.AWS.config.credentials.secretAccessKey;
    this.sessionToken = this.AWS.config.credentials.sessionToken;

    this.cognitoidentityserviceprovider =
      new this.AWS.CognitoIdentityServiceProvider({ apiVersion: "2016-04-18" });
    this.emailVerifier = new this.AWS.SES({ apiVersion: "2010-12-01" });
  }

  async RefreshCredentials() {
    if (
      this.cognitoidentityserviceprovider == null ||
      this.emailVerifier == null
    )
      return await this.GetAWSCredentials();

    if (
      this.AWS.config.credentials === null ||
      this.AWS.config.credentials.expireTime < Date.now() ||
      this.AWS.config.credentials.expired
    ) {
      return await this.GetAWSCredentials();
    }
  }

  async ListGroups(userPoolID) {
    await this.RefreshCredentials();
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.listGroups(
        {
          UserPoolId: userPoolID,
        },
        function (err, data) {
          if (err) {
            console.log("Error in ListGroups", err);
            reject(err);
          } else {
            resolve(data.Groups);
          }
        }
      );
    });
  }
  async ListUsersInGroupSingleRun(userPoolID, GroupName, NextToken = null) {
    await this.RefreshCredentials();
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.listUsersInGroup(
        {
          GroupName: GroupName,
          UserPoolId: userPoolID,
          NextToken: NextToken,
        },
        function (err, data) {
          if (err) {
            reject(err);
          } else {
            resolve(data);
          }
        }
      );
    });
  }

  updateUsersArray(response, GroupName, accumulator) {
    const data = response;

    const transformedUsers = data.Users.map((user) => {
      const attributes = {};
      user.Attributes.forEach((attr) => {
        attributes[attr.Name] = attr.Value;
      });

      return {
        Username: user.Username,
        Enabled: user.Enabled,
        UserStatus: user.UserStatus,
        Group: GroupName,
        EmailOk: attributes.email_verified === "true" ? true : false,
        ...attributes,
      };
    });

    accumulator.push(...transformedUsers);
  }
  async ListUsers(userPoolID) {
    await this.RefreshCredentials();

    const getAllUsers = async (paginationToken = null, allUsers = []) => {
      return new Promise((resolve, reject) => {
        const params = {
          UserPoolId: userPoolID,
          Limit: 60,
        };

        if (paginationToken) {
          params.PaginationToken = paginationToken;
        }

        this.cognitoidentityserviceprovider.listUsers(
          params,
          async (err, data) => {
            if (err) {
              console.log("Error in ListUsers", err);
              reject(err);
            } else {
              const combinedUsers = [...allUsers, ...data.Users];

              if (data.PaginationToken) {
                // recursively fetch next page
                resolve(getAllUsers(data.PaginationToken, combinedUsers));
              } else {
                // no more pages
                resolve(combinedUsers);
              }
            }
          }
        );
      });
    };

    return getAllUsers();
  }

  async ListUsersInGroup(userPoolID, GroupName) {
    const UsersInGroup = [];

    return this.ListUsersInGroupSingleRun(userPoolID, GroupName)
      .then((response) => {
        this.updateUsersArray(response, GroupName, UsersInGroup);
        var NextToken = response.NextToken;

        const fetchNext = (NextToken) => {
          if (!NextToken) {
            return Promise.resolve();
          }

          return this.ListUsersInGroupSingleRun(
            userPoolID,
            GroupName,
            NextToken
          ).then((response) => {
            this.updateUsersArray(response, GroupName, UsersInGroup);
            return fetchNext(response.NextToken);
          });
        };

        return fetchNext(NextToken);
      })
      .then(() => {
        return UsersInGroup;
      })
      .catch((error) => {
        console.error("Error listing users in group", error);
        throw error;
      });
  }

  async ListUsersWithGroup(userPoolID) {
    const allUsers = [];

    return this.ListGroups(userPoolID)
      .then((groups) => {
        const groupPromises = groups.map((element) =>
          this.ListUsersInGroup(userPoolID, element.GroupName).then(
            (usersInGroup) => {
              allUsers.push(...usersInGroup);
            }
          )
        );

        return Promise.all(groupPromises);
      })
      .then(() => {
        return allUsers;
      })
      .catch((error) => {
        console.error("Error listing users with group", error);
        throw error;
      });
  }

  async GetUser(userPoolID, username) {
    await this.RefreshCredentials();
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.adminGetUser(
        {
          UserPoolId: userPoolID,
          Username: username,
        },
        (err, userData) => {
          if (err) {
            console.log("Error in GetUser", err);
            reject(err);
          } else {
            // Now get the groups for the user
            this.cognitoidentityserviceprovider.adminListGroupsForUser(
              {
                UserPoolId: userPoolID,
                Username: username,
              },
              (err, groupsData) => {
                if (err) {
                  console.log("Error in ListGroupsForUser", err);
                  reject(err);
                } else {
                  // Combine user data and groups data
                  resolve({
                    ...userData,
                    Groups: groupsData.Groups || [],
                  });
                }
              }
            );
          }
        }
      );
    });
  }

  /*var params = {
    UserPoolId: UserPoolID,
    Username: Username,
  };*/
  async EnableUser(userPoolID, username) {
    const params = {
      UserPoolId: userPoolID,
      Username: username,
    };
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.adminEnableUser(
        params,
        function (err, data) {
          if (err) {
            console.log("Error", err);
            reject(err); // Reject the promise in case of error
          } else {
            resolve(data); // Resolve the promise on success
          }
        }
      );
    });
  }

  async DisableUser(userPoolID, username) {
    const params = {
      UserPoolId: userPoolID,
      Username: username,
    };
    return new Promise((resolve, reject) => {
      this.cognitoidentityserviceprovider.adminDisableUser(
        params,
        function (err, data) {
          if (err) {
            console.log("Error", err);
            reject(err); // Reject the promise in case of error
          } else {
            resolve(data); // Resolve the promise on success
          }
        }
      );
    });
  }

  async GetUserGroups() {
    return new Promise(async (resolve, reject) => {
      this.cognitoUser.getSession(function (err, session) {
        if (err) {
          reject(err);
        } else {
          var sessionIdInfo = jwtDecode(session.getIdToken().jwtToken);
          sessionStorage.setItem("UserGroups", sessionIdInfo["cognito:groups"]);
          resolve(sessionIdInfo["cognito:groups"]);
        }
      });
    });
  }
}
